<template>
	<div class="ipanel">
		<div class="head">{{title}}</div>
		<div class="ibody">
			<slot></slot>
		</div>
	</div>
</template>
<script>
	export default {
		name:"panel",
		props:["title"],
		data(){
			return {
				item:"value"
			}
		}
	}
</script>
<style scoped>
	.head{
		background: whitesmoke;
		padding:4px;
		color:grey;
		border-bottom: 1px solid lightgrey;
	}
	.ipanel{
		border:1px solid lightgrey;
		border-radius: 4px;
		margin:4px;
		overflow:hidden;
		break-inside: avoid-column;
	}
	.ibody{
		padding:10px 14px;
	}
</style>